import {
  RECEIVE_TOKEN,
  REQUEST_TOKEN,
  REQUEST_TOKEN_ERROR,
  INVALIDATE_TOKEN,
} from './types';
import STATUS from '../../globalStatuses';
import { errorToMessage } from '../../../errorMessaging';

function csrf(
  state = { csrf: {} },
  action,
) {
  switch (action.type) {
    case REQUEST_TOKEN:
      return { ...state, status: STATUS.FETCHING };
    case RECEIVE_TOKEN:
      return { ...state, status: STATUS.FETCHED, token: action.token };
    case REQUEST_TOKEN_ERROR:
      return {
        ...state,
        error: errorToMessage(action.error),
        status: STATUS.ERROR,
      };
    case INVALIDATE_TOKEN:
      return { ...state, status: STATUS.INVALIDATED };
    default:
      return state;
  }
}

export default csrf;
